import React, { useState, useEffect } from 'react';
import PropertiesComp2 from '../components/PropertiesComp2';
import SearchFilterComp2 from '../components/SearchFilterComp2';
import Footer from '../components/Footer';
import { getSearchFilterOptions, getProjectNames, getPropertyListNew, getCommunityList, getallPropertiesFilterApi } from '../services/Api';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';


const ExclusivePage = () => {
    const [typeOptions, setTypeOptions] = useState([]);
    const [handoverYears, setHandoverYears] = useState([]);
    const [budget, setBudget] = useState("");
    const [locationSelect, setLocationSelect] = useState(null);
    const [developerOptions, setDeveloperOptions] = useState([]);
    const [developer, setDeveloper] = useState(null);
    const [projectOptions, setProjectOptions] = useState([]);
    const [project, setProject] = useState(null);
    const [inputValue, setInputValue] = useState("");
    const [keywords, setKeywords] = useState([]);
    const [type, setType] = useState(null);
    const [handover, setHandover] = useState(null);
    const [page, setPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);
    const [propertyData, setPropertyData] = useState([]);
    const [searchTrigger, setSearchTrigger] = useState(0); // NEW
    const [selectedCategory, setSelectedCategory] = useState('all');
    const [selectedLocation, setSelectedLocation] = useState('All Emirates');

    const [communityOptions, setCommunityOptions] = useState([]);
    const [amenityOptions, setAmenityOptions] = useState([]);
    const [roomOptions, setRoomOptions] = useState([]);
    const [unitTypeOptions, setUnitTypeOptions] = useState([]);
    const [salesStatusOptions, setSalesStatusOptions] = useState([]);
    const [projectStatusOptions, setProjectStatusOptions] = useState([]);
    const [projectTypeOptions, setProjectTypeOptions] = useState([]);
    
    const [projectStatus, setProjectStatus] = useState([]);
    const [community, setCommunity] = useState([]);
    const [salesStatus, setSalesStatus] = useState([]);
    const [projectType, setProjectType] = useState([]);
    const [unitType, setUnitType] = useState([]);
    const [newUnitType, setNewUnitType] = useState([]);
    const [rooms, setRooms] = useState([]);
    const [facility, setFacility] = useState([]);
    const [rentalGuarantee, setRentalGuarantee] = useState([]);
    const [paymentPlan, setPaymentPlan] = useState([]);
    const [deliveryPlan, setDeliveryPlan] = useState([]);
    const [minPrice, setMinPrice] = useState('');
    const [maxPrice, setMaxPrice] = useState('');
    const [minArea, setMinArea] = useState('');
    const [maxArea, setMaxArea] = useState('');
    const [downPayment, setDownPayment] = useState('');
    const [deliveryDate, setDeliveryDate] = useState('');

    const { t } = useTranslation();
    const BATCH_SIZE = 12;

    const emirateOptions = [
        { label: 'All Emirates', value: 'All Emirates' },
        { label: 'Abu Dhabi', value: 'Abu Dhabi' },
        { label: 'Dubai', value: 'Dubai' },
        { label: 'Sharjah', value: 'Sharjah' },
        { label: 'Ajman', value: 'Ajman' },
        { label: 'Umm Al Quwain', value: 'Umm Al Quwain' },
        { label: 'Ras Al Khaimah', value: 'Ras Al Khaimah' },
        { label: 'Fujairah', value: 'Fujairah' }
    ];

    useEffect(() => {
        getsearchFilterData();
        getProjectNamesData();
        getCommunityNamesData();
        getAllFilterData();
    }, []);

    useEffect(() => {
        getPropertyData(1, 'latest', true);
    }, []);

    useEffect(() => {
        getPropertyData(1, 'latest', true);
    }, [searchTrigger, selectedCategory, selectedLocation]); // ✅ use search trigger

     const handleRest = () => {
      console.log('Resetting form states');
        setProjectStatus([]);
        setDeveloper(null);
        setProject([]);
        setSalesStatus([]);
        setProjectType([]);
        setUnitType([]);
        setNewUnitType([]);
        setRooms([]);
        setFacility([]);
        setCommunity([]);
        setRentalGuarantee([]);
        setPaymentPlan([]);
        setDeliveryPlan([]);
        setMinPrice(0);
        setMaxPrice(0);
        setMinArea(0);
        setMaxArea(0);
        setDownPayment('');
        setDeliveryDate([]);
        // setSearchTrigger(true);
    }

    const getsearchFilterData = async () => {
        try {
            const response = await getSearchFilterOptions();
            if (response.types) setTypeOptions(["Any Type", ...response.types]);
            if (response.handover_years) {
                const currentYear = new Date().getFullYear();

                // Filter out invalid years and future years (excluding the current year)
                const futureYears = response.handover_years
                    .filter(year => !isNaN(year) && Number(year) > currentYear)
                    .sort((a, b) => Number(a) - Number(b));

                // Set state with "Ready to move" at the start, followed by future years
                setHandoverYears(["Ready to move", ...futureYears]);
            }




            if (response.developers) setDeveloperOptions(["Any Developer", ...response.developers]);
        } catch (error) {
            console.error("API error:", error);
        }
    };

    const getProjectNamesData = async () => {
        const response = await getProjectNames();
        if (response?.success) {
            const options = response.data.map((item) => ({
                label: item.title,
                id: item.id
            }));
            setProjectOptions(options);
        }
    };

    const formatNumber = (value) => {
        const numericValue = value.replace(/,/g, '');
        if (!numericValue) return '';
        return Number(numericValue).toLocaleString('en-US');
    };

    const handleBudgetChange = (e) => {
        const input = e.target.value.replace(/,/g, '');
        if (/^\d*$/.test(input)) setBudget(formatNumber(input));
    };

    const handleChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        const split = value.split(',').map(k => k.trim()).filter(k => k);
        setKeywords(split);
    };
    console.log(type);

    const getPropertyData = async (currentPage, sortBy = 'price_desc', isReset = false) => {
        try {
            sortBy = "price_desc"
            setIsLoading(true);
            let categoryParam = '';
            if ((selectedCategory === 'ready_to_move')|| (projectStatus?.label === 'Ready')) {
                categoryParam = 2;
                // setGetProperty([]); // Reset properties when category changes

            }
            else if ((selectedCategory === 'off_plan') || (projectStatus?.label === 'Off Plan')){
                categoryParam = 1;
                // setGetProperty([]);
            }
            else if (selectedCategory === 'all') {
                categoryParam = 0;
                // setGetProperty([]); // Reset properties when category changes
            }

            const unitTypeLabel = newUnitType ? newUnitType.label : unitType?.label;
            const response = await getPropertyListNew(
                currentPage,
                BATCH_SIZE,
                sortBy,
                categoryParam,
                type || null,
                budget,
                handover,
                locationSelect?.value || null,
                developer?.label || null,
                project?.label || null,
                keywords || [],
                selectedLocation,
                // projectStatus?.label || null,
                salesStatus?.label || null,
                projectType?.label || null,
                unitTypeLabel,
                rooms?.label || null,
                facility?.label || null,
                community?.label || null,
                rentalGuarantee?.value || null,
                paymentPlan?.value || null,
                deliveryPlan?.value || null,
                minArea,
                maxArea,
                minPrice,
                maxPrice,
                downPayment,
                deliveryDate?.value || null
            );

            if (response?.results?.success) {
                const newProperties = response.results.data;
                setPropertyData((prev) => {
                    if (isReset || currentPage === 1) return newProperties;
                    const existingIds = new Set(prev.map(p => p.id));
                    const filteredNew = newProperties.filter(p => !existingIds.has(p.id));
                    return [...prev, ...filteredNew];
                });
            }
        } catch (error) {
            console.error("Error fetching property data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    const onPageChange = (newPage) => {
        setPage(newPage);
        getPropertyData(newPage, 'latest', false);
    };

    const getCommunityNamesData = async () => {
            const response = await getCommunityList();
            if (response?.success) {
                const communityOptions = response.data.map((item) => ({
                label: item.name, 
                id: item.id
                }));
    
                const uniqueCommunityOptions = communityOptions.filter((option, index) => {
                    return communityOptions.findIndex(o => o.id === option.id) === index;
                })
                setCommunityOptions(uniqueCommunityOptions);
            } else {
                console.error("Failed to fetch community names");
            }
        }

        const getAllFilterData = async () => {
            try {
              const response = await getallPropertiesFilterApi();
              if (response?.success) {
                const {
                  project_name: projectNames = [],
                  rooms = [],
                  unit_type = [],
                  sales_status = [],
                  community = [],
                  developer = [],
                  project_status = [],
                  project_type = [],
                  amenity = [],
                } = response.data;
        
                // map each list into whatever shape your selects need:
                //   setProjectOptions(
                //     projectNames.map((title) => ({ label: title, value: title }))
                //   );
                setRoomOptions(
                  rooms.map((r) => ({ label: String(r), value: r }))
                );
                setUnitTypeOptions(
                  unit_type.map((ut) => ({ label: ut, value: ut }))
                );
                setSalesStatusOptions(
                  sales_status.map((s) => ({ label: s, value: s }))
                );
                //   setCommunityOptions(
                //     community.map((c) => ({ label: c, value: c }))
                //   );
                setDeveloperOptions(
                  developer.map((d) => ({ label: d, value: d }))
                );
                setProjectStatusOptions(
                  project_status.map((ps) => ({ label: ps, value: ps }))
                );
                setProjectTypeOptions(
                  project_type.map((pt) => ({ label: pt, value: pt }))
                );
                setAmenityOptions(
                  amenity.map((a) => ({ label: a, value: a }))
                );
              } else {
                console.error("Failed to fetch filter data:", response.error);
              }
            } catch (err) {
              console.error("Error calling filter API:", err);
            }
          };

    return (
        <div className="pt-6">
            <div className="container mx-auto pt-24 pb-15">
                <SearchFilterComp2
                    type={type}
                    setType={setType}
                    budget={budget}
                    setBudget={setBudget}
                    handover={handover}
                    setHandover={setHandover}
                    typeOptions={typeOptions}
                    handoverYears={handoverYears}
                    handleBudgetChange={handleBudgetChange}
                    emirateOptions={emirateOptions}
                    locationSelect={locationSelect}
                    setLocationSelect={setLocationSelect}
                    developer={developer}
                    setDeveloper={setDeveloper}
                    developerOptions={developerOptions}
                    project={project}
                    setProject={setProject}
                    projectOptions={projectOptions}
                    inputValue={inputValue}
                    handleChange={handleChange}
                    setPage={setPage}
                    page={page}
                    setPropertyData={setPropertyData}
                    setIsLoading={setIsLoading}
                    setSearchTrigger={setSearchTrigger} // ✅ PASS THIS,
                    setProjectStatus={setProjectStatus}
                    projectStatus={projectStatus}
                    setSalesStatus={setSalesStatus}
                    salesStatus={salesStatus}
                    setProjectType={setProjectType}
                    projectType={projectType}
                    setUnitType={setUnitType}
                    unitType={unitType}
                    setNewUnitType={setNewUnitType}
                    newUnitType={newUnitType}
                    setRooms={setRooms}
                    rooms={rooms}
                    setFacility={setFacility}
                    facility={facility}
                    setCommunity={setCommunity}
                    community={community}
                    setRentalGuarantee={setRentalGuarantee}
                    rentalGuarantee={rentalGuarantee}
                    setPaymentPlan={setPaymentPlan}
                    paymentPlan={paymentPlan}
                    setDeliveryPlan={setDeliveryPlan}
                    deliveryPlan={deliveryPlan}
                    setMinPrice={setMinPrice}
                    minPrice={minPrice}
                    setMaxPrice={setMaxPrice}
                    maxPrice={maxPrice}
                    setMinArea={setMinArea}
                    minArea={minArea}
                    setMaxArea={setMaxArea}
                    maxArea={maxArea}
                    setDownPayment={setDownPayment}
                    downPayment={downPayment}
                    setDeliveryDate={setDeliveryDate}
                    deliveryDate={deliveryDate}
                    communityOptions={communityOptions}
                    roomOptions={roomOptions}
                    unitTypeOptions={unitTypeOptions}
                    salesStatusOptions={salesStatusOptions}
                    projectStatusOptions={projectStatusOptions}
                    projectTypeOptions={projectTypeOptions}
                    amenityOptions={amenityOptions}
                    isLoading={isLoading}
                    handleRest={handleRest}
                

                   
                />
            </div>
            <PropertiesComp2
                sortBy="price_desc"
                heading={t('exclusive_projects')}
                paddingClasses="pt-[100px] lg:pt-[50px]"
                propertyData={propertyData}
                onPageChange={onPageChange}
                page={page}
                isLoading={isLoading}
                setSelectedCategory={setSelectedCategory}
                selectedCategory={selectedCategory}
                selectedLocation={selectedLocation}
                setSelectedLocation={setSelectedLocation}

            />
            <Footer />
        </div>
    );
};

export default ExclusivePage;
